@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.TutorialHuds .TutorialHud {
  z-index: 20;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8em;
  height: 4em;
  margin-top: -2em;
  margin-left: -4em;
  pointer-events: none;
  visibility: hidden;
}
.TutorialHuds .TutorialHud[isRendered] {
  visibility: visible;
}
.TutorialHuds .TutorialHud .TutorialBox {
  padding: 0.33em 0.53394em;
  text-align: center;
  pointer-events: all;
  border-radius: 0.1em;
  color: #f0ead6;
  background-color: #111111;
}
.TutorialHuds .TutorialHud .TutorialBox .Text {
  font-size: 0.25em;
}
.TutorialHuds .TutorialHud .TutorialBox .Text [element=water] {
  color: #639bff;
}
.TutorialHuds .TutorialHud .TutorialBox .Text [element=fire] {
  color: #d54b33;
}
.TutorialHuds .TutorialHud .TutorialBox .Text [element=earth] {
  color: #62C370;
}
.TutorialHuds .TutorialHud .TutorialBox .Link {
  opacity: 0.5;
  font-size: 0.25em;
  width: 5em;
  margin: auto;
  margin-top: 0.5em;
}
.TutorialHuds .TutorialHud .TutorialBox .Link:hover {
  opacity: 1;
  color: #d54b33;
  cursor: pointer;
}
.RollingHud {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 0.5em;
  position: absolute;
  top: 0.5em;
  right: 0.5em;
  z-index: 10000;
}
.RollingHud .DoneButton,
.RollingHud .RerollButton {
  font-size: 0.8em;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #111111;
  font-family: var(--header-font);
  opacity: 0.5;
  width: 6em;
  height: 4em;
  margin-bottom: 0.5em;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}
.RollingHud .DoneButton[isEnabled],
.RollingHud .RerollButton[isEnabled] {
  opacity: 1;
}
.RollingHud .DoneButton[isHighlighted],
.RollingHud .RerollButton[isHighlighted] {
  font-size: 1em;
}
.RollingHud .DoneButton.DoneButton,
.RollingHud .RerollButton.DoneButton {
  background-image: url("@frog/source/assets/images/dice-tactics/button.png");
}
.RollingHud .DoneButton.DoneButton:hover,
.RollingHud .RerollButton.DoneButton:hover {
  transform: scale(1.1);
}
.RollingHud .DoneButton.RerollButton,
.RollingHud .RerollButton.RerollButton {
  width: 10em;
  background-image: url("@frog/source/assets/images/dice-tactics/undoblank.png");
}
.RollingHud .DoneButton.RerollButton:hover,
.RollingHud .RerollButton.RerollButton:hover {
  transform: rotate(4deg);
}
